export default __webpack_public_path__ + "static/media/90.dcce7e77.png";